import { PlacementTask, PlacementTaskStatus } from 'enums';
import { PartialSubmission } from 'types';
import { logger } from 'utils';
import { useMutateSubmissionPlacementTask } from './api/submission-placement-task';

export function useCompletePlacementTask() {
  const { updateStatus } = useMutateSubmissionPlacementTask();

  const completePlacementTask = async (
    submission: PartialSubmission,
    placementTask: PlacementTask,
    options?: {
      onSuccess?: () => Promise<void>;
      metadata?: { emailMessageId?: string };
    },
  ) => {
    const task = submission.placementTasks?.find(
      (t) => t.placementTask === placementTask && t.status === PlacementTaskStatus.InProgress,
    );

    if (!task?.id) {
      logger.log('warning', {
        message: 'Cannot complete placement task - not found this task in progress for submission',
        submissionId: submission.id,
        placementTask,
      });
      return;
    }

    try {
      await updateStatus.mutateAsync({
        id: task.id,
        data: {
          status: PlacementTaskStatus.Completed,
          ...(options?.metadata && { metadata: options.metadata }),
        },
      });

      logger.log('info', {
        message: 'Placement task completed successfully',
        taskId: task.id,
        submissionId: submission.id,
        placementTask,
        ...(options?.metadata?.emailMessageId && { emailMessageId: options.metadata.emailMessageId }),
      });

      if (options?.onSuccess) {
        await options.onSuccess();
      }
    } catch (error) {
      logger.log('error', {
        message: 'Failed to complete placement task',
        error: error as Error,
        submissionId: submission.id,
        placementTask,
        taskId: task.id,
      });
      // Don't throw - let the operation continue
    }
  };

  return { completePlacementTask };
}
